// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";
import "./showcase/preview_stream_actions";
import "./meta_pixel";


import { library, dom, config } from "@fortawesome/fontawesome-svg-core";

// El CSS de tamaño (.svg-inline--fa) se carga estáticamente vía SCSS
// (application.scss / page.scss). Desactivamos la inyección en runtime para
// eliminar el FOUC de iconos gigantes antes de que el JS inserte el <style>.
config.autoAddCss = false;


// Solid icons
import {
  faLock,
  faCog,
  faUserCog,
  faCircleCheck,
  faCircleXmark,
  faCircleExclamation,
  faXmark,
  faTrash,
  faChevronLeft,
  faCheckCircle,
  faMinus,
  faPlus,
  faInfoCircle,
  faTriangleExclamation,
  faImage,
  faStar,
  faEnvelope,
  faCaretDown,
  faCaretRight,
  faBox as faBoxSolid,
  faCalendar as faCalendarSolid,
  faCheck,
  faChevronDown,
  faCopy,
  faEllipsis,
  faEllipsisVertical,
  faEyeSlash,
  faFolderGear as faFolderGearSolid,
  faMagnifyingGlass,
  faPen as faPenSolid,
  faPenToSquare,
  faUserGroup as faUserGroupSolid,
  faGripDotsVertical,
  faArrowRight,
  faChevronRight,
  faFileArrowDown,
  faFileArrowUp,
  faFile,
  faVideo as faVideoSolid,
  faMusic as faMusicSolid,
  faFilePen as faFilePenSolid,
  faLink as faLinkSolid,
  faLocationDot as faLocationDotSolid,
  faArrowRotateBack,
  faPause,
  faPlay,
  faUpload,
  faFileVideo as faFileVideoSolid,
  faExternalLink,
  faQrcode,
  faAngleRight,
  faEye,
  faBold,
  faItalic,
  faUnderline,
  faListUl,
  faListOl,
  faHeading,
  faParagraph,
  faH1,
  faH2,
  faH3,
  faH4,
  faH5,
  faH6,
  faStrikethrough,
  faSpinner,
  faUsers as faUsersSolid,
  faGrid,
  faClipboardCheck,
  faFileInvoice,
  faFileDownload,
  faTag,
  faMapPin,
  faDesktop as faDesktopSolid,
  faFillDrip as faFillDripSolid,
  faMessage,
  faBookOpen,
  faShieldHalved,
  faRightFromBracket,
  faPowerOff,
  faArrowLeftToLine,
  faArrowLeft,
  faBookmark,
  faPaperclip,
  faThumbsUp as faThumbsUpSolid,
  faThumbtack as faThumbtackSolid,
  faRectangleHistory as faRectangleHistorySolid,
  faRotateRight,
  faIcons as faIconsSolid,
} from "@fortawesome/pro-solid-svg-icons";

// Regular icons
import {
  faCircleCheck as faCircleCheckRegular,
  faCube as faCubeRegular,
  faEllipsisVertical as faEllipsisVerticalRegular,
  faGalleryThumbnails as faGalleryThumbnailsRegular,
  faImageLandscape as faImageLandscapeRegular,
  faPlus as faPlusRegular,
  faText as faTextRegular,
  faFillDrip as faFillDripRegular,
  faPhotoVideo as faPhotoVideoRegular,
  faUser as faUserRegular,
  faUserGroup as faUserGroupRegular,
  faBoxArchive as faBoxArchiveRegular,
  faCalendar as faCalendarRegular,
  faCalendarUsers as faCalendarUsersRegular,
  faCircleInfo as faCircleInfoRegular,
  faCamcorder as faCamcorderRegular,
  faCameraWeb as faCameraWebRegular,
  faCheck as faCheckRegular,
  faCog as faCogRegular,
  faComments as faCommentsRegular,
  faEyeSlash as faEyeSlashRegular,
  faFiles as faFilesRegular,
  faFolder as faFolderRegular,
  faFolders as faFoldersRegular,
  faGraduationCap as faGraduationCapRegular,
  faHome as faHomeRegular,
  faLink as faLinkRegular,
  faLocationDot as faLocationDotRegular,
  faMicrophone as faMicrophoneRegular,
  faPenToSquare as faPenToSquareRegular,
  faPeopleGroup as faPeopleGroupRegular,
  faRectangleHistory as faRectangleHistoryRegular,
  faTrash as faTrashRegular,
  faTrashCan as faTrashCanRegular,
  faUpFromBracket as faUpFromBracketRegular,
  faUsers as faUsersRegular,
  faVideo as   faVideoRegular,
  faBox as faBoxRegular,
  faBookmark as faBookmarkRegular,
  faFolderGear as faFolderGearRegular,
  faAnglesUpDown as faAnglesUpDownRegular,
  faCopy as faCopyRegular,
  faBars as faBarsRegular,
  faBarsFilter as faBarsFilterRegular,
  faSliders as faSlidersRegular,
  faArrowLeft as faArrowLeftRegular,
  faFileImport as faFileImportRegular,
  faCalendarDays as faCalendarDaysRegular,
  faFolderGrid as faFolderGridRegular,
  faFilePen as faFilePenRegular,
  faCloudArrowUp as faCloudArrowUpRegular,
  faSignalStream as faSignalStreamRegular,
  faPerson as faPersonRegular,
  faGears as faGearsRegular,
  faEye as faEyeRegular,
  faXmarkLarge as faXmarkLargeRegular,
  faFilePdf as faFilePdfRegular,
  faFileArrowDown as faFileArrowDownRegular,
  faRotate as faRotateRegular,
  faUpload as faUploadRegular,
  faDroplet as faDropletRegular,
  faLock as faLockRegular,
  faFileLines as faFileLinesRegular,
  faListTree as faListTreeRegular,
  faTag as faTagRegular,
  faScanner as faScannerRegular,
  faClock as faClockRegular,
  faFile as faFileRegular,
  faComment as faCommentRegular,
  faCommentSlash as faCommentSlashRegular,
  faCamera as faCameraRegular,
  faCartShopping as faCartShoppingRegular,
  faDollarSign as faDollarSignRegular,
  faEnvelope as faEnvelopeRegular,
  faGripDotsVertical as faGripDotsVerticalRegular,
  faAlignLeft as faAlignLeftRegular,
  faAlignCenter as faAlignCenterRegular,
  faAlignRight as faAlignRightRegular,
  faCode as faCodeRegular,
  faStrikethrough as faStrikethroughRegular,
  faDesktop as faDesktopRegular,
  faPuzzlePiece as faPuzzlePieceRegular,
  faPenPaintbrush as faPenPaintbrushRegular,
  faBook as faBookRegular,
  faFolderOpen as faFolderOpenRegular,
  faChalkboardUser as faChalkboardUserRegular,
  faList as faListRegular,
  faListCheck as faListCheckRegular,
  faArrowRotateLeft as faArrowRotateLeftRegular,
  faChartLine as faChartLineRegular,
  faFileInvoice as faFileInvoiceRegular,
  faBadgePercent as faBadgePercentRegular,
  faLayerGroup as faLayerGroupRegular,
  faTrashAlt as faTrashAltRegular,
  faCircleUser as faCircleUserRegular,
  faBell as faBellRegular,
  faMoneyBill as faMoneyBillRegular,
  faCalendarAlt as faCalendarAltRegular,
  faIcons as faIconsRegular,
  faArrowRightToBracket as faArrowRightToBracketRegular,
  faArrowRight as faArrowRightRegular,
  faArrowUpRightFromSquare as faArrowUpRightFromSquareRegular,
  faMobileNotch as faMobileNotchRegular,
  faTabletButton as faTabletButtonRegular,
  faThumbsUp as faThumbsUpRegular,
  faThumbtack as faThumbtackRegular,
  faMessageQuestion as faMessageQuestionRegular,
  faPhotoFilmMusic as faPhotoFilmMusicRegular,
  faTriangleExclamation as faTriangleExclamationRegular,
  faChevronRight as faChevronRightRegular,
  faCreditCard as faCreditCardRegular,
  faReceipt as faReceiptRegular,
  faXmark as faXmarkRegular,
  faBrowser as faBrowserRegular,
  faCalendarDay as faCalendarDayRegular,
  faChartArea as faChartAreaRegular,
  faPeopleLine as faPeopleLineRegular,
  faRepeat as faRepeatRegular,
  faSquareList as faSquareListRegular,
  faPaperPlane as faPaperPlaneRegular,
  faReply as faReplyRegular,
  faRightLeft as faRightLeftRegular,
} from "@fortawesome/pro-regular-svg-icons";

// Duotone icons
import {
  faCalendarDays as faCalendarDaysDuotone,
  faCalendarUsers as faCalendarUsersDuotone,
  faFolderGrid as faFolderGridDuotone,
  faGraduationCap as faGraduationCapDuotone,
  faCrown as faCrownDuotone,
  faUsersLine as faUsersLineDuotone,
  faCirclePlay as faCirclePlayDuotone,
  faVideoArrowUpRight as faVideoArrowUpRightDuotone,
  faArrowDownToBracket as faArrowDownToBracketDuotone,
} from "@fortawesome/pro-duotone-svg-icons";

// Light icons
import {
  faComments,
  faCameraWeb,
  faPhotoFilmMusic,
  faCar,
  faCarrot,
  faHouse,
  faMask,
  faMusic,
  faCloud,
  faBell,
  faPen,
  faPlus as faPlusLight,
  faMinus as faMinusLight,
  faShare,
  faPrint,
  faCartPlus,
  faFire,
  faVideo,
  faHouseHeart,
  faPeopleGroup,
  faMessagesQuestion,
  faThumbsUp,
  faEnvelope as faEnvelopeLight,
  faCircle0,
  faCircle1,
  faCircle2,
  faCircle3,
  faCircle4,
  faCircle5,
  faCircle6,
  faCircle7,
  faCircle8,
  faCircle9,
  faTableLayout,
  // Light — page editor presets (paridad con WebsiteEditorSection(Item)FormPresets)
  faStar as faStarLight,
  faGrid2,
  faText as faTextLight,
  faTags,
  faList as faListLight,
  faImage as faImageLight,
  faArrowPointer,
  faDollar,
  faDollarCircle,
  faTimer,
  faAddressCard,
  faClipboardCheck as faClipboardCheckLight,
  faShareNodes,
  faFile as faFileLight,
} from "@fortawesome/pro-light-svg-icons";

// Brands icons
import {
  faInstagram,
  faFacebook,
  faTwitter,
  faTiktok,
  faWhatsapp,
  faYoutube,
  faSpotify,
  faApple,
  faGoogle,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

// Add all icons to library
library.add(
  // Solid
  faLock,
  faCog,
  faUserCog,
  faCircleCheck,
  faCircleXmark,
  faCircleExclamation,
  faXmark,
  faPenSolid,
  faTrash,
  faChevronLeft,
  faCheckCircle,
  faMinus,
  faPlus,
  faInfoCircle,
  faTriangleExclamation,
  faImage,
  faStar,
  faEnvelope,
  faCaretDown,
  faCaretRight,
  faCheck,
  faChevronDown,
  faCopy,
  faEllipsis,
  faEllipsisVertical,
  faEyeSlash,
  faFolderGearSolid,
  faMagnifyingGlass,
  faPenToSquare,
  faUserGroupSolid,
  faBoxSolid,
  faCalendarSolid,
  faGripDotsVertical,
  faArrowRight,
  faChevronRight,
  faFileArrowDown,
  faFileArrowUp,
  faFile,
  faVideoSolid,
  faMusicSolid,
  faFilePenSolid,
  faLinkSolid,
  faLocationDotSolid,
  faArrowRotateBack,
  faRotateRight,
  faIconsSolid,
  faPause,
  faPlay,
  faUpload,
  faFileVideoSolid,
  faExternalLink,
  faQrcode,
  faAngleRight,
  faEye,
  faUsersSolid,
  faGrid,
  faClipboardCheck,
  faFileInvoice,
  faFileDownload,
  faTag,
  faMapPin,
  faDesktopSolid,
  faFillDripSolid,
  faMessage,
  faBookOpen,
  faShieldHalved,
  faRightFromBracket,
  faPowerOff,
  faArrowLeftToLine,
  faArrowLeft,
  faBookmark,
  faPaperclip,
  faThumbsUpSolid,
  faThumbtackSolid,
  faRectangleHistorySolid,
  // Regular
  faCircleCheckRegular,
  faCubeRegular,
  faEllipsisVerticalRegular,
  faGalleryThumbnailsRegular,
  faImageLandscapeRegular,
  faPlusRegular,
  faTextRegular,
  faFillDripRegular,
  faPhotoVideoRegular,
  faUserRegular,
  faUserGroupRegular,
  faBoxArchiveRegular,
  faCalendarRegular,
  faCalendarUsersRegular,
  faCircleInfoRegular,
  faCamcorderRegular,
  faCameraWebRegular,
  faCheckRegular,
  faCogRegular,
  faCommentsRegular,
  faEyeSlashRegular,
  faFilesRegular,
  faFolderRegular,
  faFoldersRegular,
  faGraduationCapRegular,
  faHomeRegular,
  faLinkRegular,
  faLocationDotRegular,
  faMicrophoneRegular,
  faPenToSquareRegular,
  faPeopleGroupRegular,
  faRectangleHistoryRegular,
  faTrashRegular,
  faTrashCanRegular,
  faUpFromBracketRegular,
  faUsersRegular,
  faVideoRegular,
  faBoxRegular,
  faBookmarkRegular,
  faFolderGearRegular,
  faAnglesUpDownRegular,
  faCopyRegular,
  faBarsRegular,
  faBarsFilterRegular,
  faSlidersRegular,
  faArrowLeftRegular,
  faFileImportRegular,
  faCalendarDaysRegular,
  faFolderGridRegular,
  faFilePenRegular,
  faCloudArrowUpRegular,
  faSignalStreamRegular,
  faPersonRegular,
  faGearsRegular,
  faEyeRegular,
  faXmarkLargeRegular,
  faFilePdfRegular,
  faFileArrowDownRegular,
  faRotateRegular,
  faUploadRegular,
  faDropletRegular,
  faLockRegular,
  faFileLinesRegular,
  faListTreeRegular,
  faTagRegular,
  faScannerRegular,
  faClockRegular,
  faFileRegular,
  faCommentRegular,
  faCommentSlashRegular,
  faCameraRegular,
  faCartShoppingRegular,
  faDollarSignRegular,
  faEnvelopeRegular,
  faGripDotsVerticalRegular,
  faAlignLeftRegular,
  faAlignCenterRegular,
  faAlignRightRegular,
  faCodeRegular,
  faStrikethroughRegular,
  faDesktopRegular,
  faPuzzlePieceRegular,
  faPenPaintbrushRegular,
  faBookRegular,
  faFolderOpenRegular,
  faChalkboardUserRegular,
  faListRegular,
  faListCheckRegular,
  faArrowRotateLeftRegular,
  faChartLineRegular,
  faFileInvoiceRegular,
  faBadgePercentRegular,
  faLayerGroupRegular,
  faTrashAltRegular,
  faCircleUserRegular,
  faBellRegular,
  faMoneyBillRegular,
  faCalendarAltRegular,
  faIconsRegular,
  faArrowRightToBracketRegular,
  faArrowRightRegular,
  faArrowUpRightFromSquareRegular,
  faMobileNotchRegular,
  faTabletButtonRegular,
  faThumbsUpRegular,
  faThumbtackRegular,
  faMessageQuestionRegular,
  faPhotoFilmMusicRegular,
  faTriangleExclamationRegular,
  faChevronRightRegular,
  faCreditCardRegular,
  faReceiptRegular,
  faXmarkRegular,
  faBrowserRegular,
  faCalendarDayRegular,
  faChartAreaRegular,
  faPeopleLineRegular,
  faRepeatRegular,
  faSquareListRegular,
  faPaperPlaneRegular,
  faReplyRegular,
  faRightLeftRegular,
  // Solid — TipTap editor toolbar
  faBold,
  faItalic,
  faUnderline,
  faListUl,
  faListOl,
  faHeading,
  faParagraph,
  faH1,
  faH2,
  faH3,
  faH4,
  faH5,
  faH6,
  faStrikethrough,
  faSpinner,
  // Light
  faComments,
  faCameraWeb,
  faPhotoFilmMusic,
  faCar,
  faCarrot,
  faHouse,
  faMask,
  faMusic,
  faCloud,
  faBell,
  faPen,
  faPlusLight,
  faMinusLight,
  faShare,
  faPrint,
  faCartPlus,
  faFire,
  faVideo,
  faHouseHeart,
  faPeopleGroup,
  faMessagesQuestion,
  faThumbsUp,
  faEnvelopeLight,
  faCircle0,
  faCircle1,
  faCircle2,
  faCircle3,
  faCircle4,
  faCircle5,
  faCircle6,
  faCircle7,
  faCircle8,
  faCircle9,
  faTableLayout,
  // Light — page editor presets
  faStarLight,
  faGrid2,
  faTextLight,
  faTags,
  faListLight,
  faImageLight,
  faArrowPointer,
  faDollar,
  faDollarCircle,
  faTimer,
  faAddressCard,
  faClipboardCheckLight,
  faShareNodes,
  faFileLight,
  // Duotone
  faCalendarDaysDuotone,
  faCalendarUsersDuotone,
  faFolderGridDuotone,
  faGraduationCapDuotone,
  faCrownDuotone,
  faUsersLineDuotone,
  faCirclePlayDuotone,
  faVideoArrowUpRightDuotone,
  faArrowDownToBracketDuotone,
  // Brands
  faInstagram,
  faFacebook,
  faTwitter,
  faTiktok,
  faWhatsapp,
  faYoutube,
  faSpotify,
  faApple,
  faGoogle,
  faLinkedin
);

dom.watch();
